module.exports = __webpack_public_path__ + "img/Question-bg-4.f91379d0.png";